import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import LocaleContext from '../../context/LocaleProvider';
import Img from 'gatsby-image';
import Title from '../Title/Title';
import SEO from '../SEO';
import {
  ArticleMainContainer,
  ArticleHeroContainer,
} from '../ArticleTemplate/ArticleTemplate.css';
import { ContactForm, ContactContainer } from './contact.css';
import { encode } from '../../functions/encode';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { theme as localTheme } from '../../styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import CircleSVG from '../CircleSVG/CircleSVG';
import { Parallax } from 'react-scroll-parallax';
import Transition from '../Transition/Transition';
import Footer from '../Footer/Footer';

const SubmitButton = withStyles((theme) => ({
  root: {
    color: '#ffffff',
    backgroundColor: localTheme.colors.primaryred,
    '&:hover': {
      backgroundColor: localTheme.colors.primaryblue,
    },
  },
}))(Button);

const ContactLayout = ({ data, pageContext: { locale, uid }, location }) => {
  const lang = useContext(LocaleContext);
  const [formState, setFormState] = useState({});
  const [formSuccess, setFormSuccess] = useState(false);
  const i18n = lang.i18n[lang.locale];
  const query = data.contact.data;

  useEffect(() => {
    document.body.classList.add('is-red');

    return () => document.body.classList.remove('is-red');
  }, []);

  const changeHandler = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    const body = encode({ 'form-name': e.target.name, ...formState });

    try {
      const form = await axios.post('/', body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (form.status === 200) {
        // eslint-disable-next-line no-console
        setFormSuccess(true);
      }
    } catch (err) {
      const errors = err.response.data.errors;

      if (errors) {
        errors.forEach((error, index) => {
          // eslint-disable-next-line no-console
          console.error(`error.param ${index}`, error.param);
          // eslint-disable-next-line no-console
          console.error(`error.msg ${index}`, error.msg);
        });
      }
    }
  };

  return (
    <Transition>
      <ContactContainer>
        <SEO location={location} pathname={location.pathname} locale={locale} />
        <ArticleMainContainer>
          <ArticleHeroContainer>
            {query.image && query.image.localFile ? (
              <Img
                fluid={query.image.localFile.childImageSharp.fluid}
                imgStyle={{ objectFit: 'contain' }}
                className='ArticleTemplateHero__Img'
              />
            ) : (
              ''
            )}
          </ArticleHeroContainer>
          <div>
            {query && query.title ? (
              <Title
                type='h2_secondary'
                customClassName='ArticleTemplate_Title'
              >
                {query.title.text}
              </Title>
            ) : (
              ''
            )}
          </div>
          <ContactForm
            name='contact'
            data-netlify-honeypot='bot-field'
            method='POST'
            data-netlify='true'
            id='ContactForm'
            onSubmit={submitHandler}
            validate
          >
            {query.full_name_label?.text &&
            query.full_name_placeholder?.text ? (
              <FormControl>
                <InputLabel shrink htmlFor='fullname'>
                  {query.full_name_label.text}
                </InputLabel>
                <TextField
                  required
                  type='text'
                  id='fullname-required'
                  name='fullname'
                  placeholder={query.full_name_placeholder.text}
                  onChange={changeHandler}
                  variant='outlined'
                />
              </FormControl>
            ) : (
              ''
            )}
            {query.email_label?.text && query.email_placeholder?.text ? (
              <FormControl>
                <InputLabel shrink htmlFor='fullname'>
                  {query.email_label.text}
                </InputLabel>
                <TextField
                  required
                  type='email'
                  id='email-required'
                  name='email'
                  placeholder={query.email_placeholder.text}
                  onChange={changeHandler}
                  variant='outlined'
                />
              </FormControl>
            ) : (
              ''
            )}
            {query.company_label?.text && query.company_placeholder?.text ? (
              <FormControl>
                <InputLabel shrink htmlFor='fullname'>
                  {query.company_label.text}
                </InputLabel>
                <TextField
                  type='text'
                  id='company'
                  name='company'
                  placeholder={query.company_placeholder.text}
                  onChange={changeHandler}
                  variant='outlined'
                />
              </FormControl>
            ) : (
              ''
            )}
            {query.optional_label?.text && query.optional_placeholder?.text ? (
              <FormControl>
                <InputLabel shrink htmlFor='fullname'>
                  {query.optional_label.text}
                </InputLabel>
                <TextField
                  required
                  text='text'
                  id='other'
                  name='other'
                  placeholder={query.optional_placeholder.text}
                  onChange={changeHandler}
                  variant='outlined'
                />
              </FormControl>
            ) : (
              ''
            )}
            {query.textarea_label?.text && query.textarea_placeholder?.text ? (
              <FormControl>
                <InputLabel shrink htmlFor='fullname'>
                  {query.textarea_label.text}
                </InputLabel>
                <TextField
                  id='message'
                  name='message'
                  placeholder={query.textarea_placeholder.text}
                  multiline
                  rows={4}
                  onChange={changeHandler}
                  variant='outlined'
                  required
                />
              </FormControl>
            ) : (
              ''
            )}
            <SubmitButton type='submit' variant='contained'>
              {formSuccess
                ? query.thank_you_message.text
                : query.submit_button_text.text}
            </SubmitButton>
          </ContactForm>
          <Parallax
            className='BigCircle__Parralax'
            y={[-15, 85]}
            tagOuter='div'
          >
            <CircleSVG fill='#ffffff' />
          </Parallax>
        </ArticleMainContainer>
        <Footer />
      </ContactContainer>
    </Transition>
  );
};

ContactLayout.propTypes = {
  location: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export default ContactLayout;
